import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import qs from 'qs';

import { getFormValues, change, clearFields, reset, submit } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import withTheme from '@material-ui/core/styles/withTheme';
import withWidth from '@material-ui/core/withWidth';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Progress from 'components/common/Progress';
import Layout from 'components/common/Layout';
import NavigationFilter from 'components/workflow/NavigationFilter';
import OrdersFilter from 'components/workflow/OrdersFilter';
import OrdersTable, { OrdersTableNoBody } from 'components/workflow/OrdersTable';
import OrdersActionsBar from 'components/workflow/OrdersActionsBar';
import PrintDialog from 'components/common/PrintDialog';
import DocumentsSignDialog from 'components/common/DocumentsSignDialog';
import Snackbar from 'components/common/Snackbar';
import Button from 'components/common/Button';
import StickyToolbar from 'components/common/StickyToolbar';

import { fetchOrders, clearOrders, updateOrderSuccess } from 'redux/modules/orders';
import { fetchArchiveOrders, clearArchiveOrders } from 'redux/modules/archiveOrders';
import {
  addRouterParamsRedirect,
  addRouterParamsPageSettings,
} from 'redux/modules/routerParams';
import { addNotification } from 'redux/modules/notifications';
import { fetchBusiness } from 'redux/modules/business';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import objectDiff from 'utils/objectDiff';
import throttle from 'utils/throttle';
import formatPrice from 'utils/formatPrice';
import formatSinglePlural from 'utils/formatSinglePlural';
import formatOrderNumber from 'utils/formatOrderNumber';
import * as validate from 'utils/validate';

import { appTitle, titleSeparator } from 'config/helmetSettings';
import delayedRenderStep from 'config/delayedRenderStep';
import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';
import timeFormat from 'config/timeFormat';

const styles = theme => ({
  expansionPanelDetails: {
    padding: 0,
  },
  tableContainer: {
    paddingTop: 130,
    [theme.breakpoints.down('sm')]: {
      paddingTop: 89,
    },
  },
  layout: {
    overflow: 'hidden',
  },
});

const workflowStateById = {
  1: 'Intake',
  2: 'Delivery',
  3: 'Billing',
  4: 'Collection',
  5: 'Paid',
};

class Orders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDialogOpen: false,
      printDialogOpen: false,
      signDialogOpen: false,
      printFormValues: null,
      printDialogOrder: null,
      syncUpdatesSnackbarOpen: false,
      syncUpdatesSnackbarText: 'You are trying to update order lines from different orders, proceed?',
      syncUpdatesSnackbarButtons: true,
      groupedUpdateSnackbarOpen: false,
      groupedUpdateValues: null,
      groupedUpdateOrderID: null,
      groupedUpdateEmptyDriverIDs: null,
      groupedUpdateEmptyDateOfDeliveryIDs: null,
      ordersActionsBarEntered: false,
      orders: props.orders.slice(0, delayedRenderStep),
      limit: 10,
      offset: 0,
      toolbarHeight: 0,
      toolbarExpanded: false,
      mobileFilterExpanded: ['xs', 'sm'].indexOf(props.width) === -1,
      mobileFilterHeight: 0,
    };

    this.groupedUpdate = false;

    this.onRequest = this.onRequest.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
    this.onSelectedOrderLinesPrint = this.onSelectedOrderLinesPrint.bind(this);
    this.onPrintDialogClose = this.onPrintDialogClose.bind(this);
    this.onPrintDialogSign = this.onPrintDialogSign.bind(this);
    this.onSignDialogClose = this.onSignDialogClose.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.onFormSubmitSuccess = this.onFormSubmitSuccess.bind(this);
    this.onFormTextFieldBlur = this.onFormTextFieldBlur.bind(this);
    this.onGroupedUpdateConfirm = this.onGroupedUpdateConfirm.bind(this);
    this.onGroupedUpdateSnackbarClose = this.onGroupedUpdateSnackbarClose.bind(this);
    this.onSyncUpdatesConfirm = this.onSyncUpdatesConfirm.bind(this);
    this.onSyncUpdatesSnackbarClose = this.onSyncUpdatesSnackbarClose.bind(this);
    this.onSortingChange = this.onSortingChange.bind(this);
    this.onOrdersActionsBarEntered = this.onOrdersActionsBarEntered.bind(this);
    this.onOrdersActionsBarExited = this.onOrdersActionsBarExited.bind(this);
    this.onTableScroll = this.onTableScroll.bind(this);
    this.onWindowKeyDowm = this.onWindowKeyDowm.bind(this);
    this.onToolbarResize = this.onToolbarResize.bind(this);
    this.onWindowMessage = this.onWindowMessage.bind(this);
    this.onMobileFilterBottonClick = this.onMobileFilterBottonClick.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentWillMount() {
    const { location, actions, scheduleOrdersFilterValues, tabID } = this.props;
    this.props.actions.clearOrders();
    if (location.state && location.state.fromSchedule) {
      if (scheduleOrdersFilterValues.Filters) {
        if (scheduleOrdersFilterValues.Filters['Date of Delivery']
          && scheduleOrdersFilterValues.Filters['Date of Delivery'][0]) {
          const dateOfDeliveryFrom = scheduleOrdersFilterValues.Filters['Date of Delivery'][0].value.split('-')[0];
          const dateOfDeliveryTo = scheduleOrdersFilterValues.Filters['Date of Delivery'][0].value.split('-')[1];
          actions.change(`${tabID}-workflow-ordersFilter`, 'Date of Delivery From', dateOfDeliveryFrom);
          actions.change(`${tabID}-workflow-ordersFilter`, 'Date of Delivery To', dateOfDeliveryTo);
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Date of Delivery', [{
            value: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
            label: `${dateOfDeliveryFrom}-${dateOfDeliveryTo}`,
          }]);
        } else {
          actions.clearFields(`${tabID}-workflow-ordersFilter`, 'Date of Delivery From');
          actions.clearFields(`${tabID}-workflow-ordersFilter`, 'Date of Delivery To');
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Date of Delivery', []);
        }
        if (scheduleOrdersFilterValues.Filters['Date of Service']
          && scheduleOrdersFilterValues.Filters['Date of Service'][0]) {
          const dateOfServiceFrom = scheduleOrdersFilterValues.Filters['Date of Service'][0].value.split('-')[0];
          const dateOfServiceTo = scheduleOrdersFilterValues.Filters['Date of Service'][0].value.split('-')[1];
          actions.change(`${tabID}-workflow-ordersFilter`, 'Date of Service From', dateOfServiceFrom);
          actions.change(`${tabID}-workflow-ordersFilter`, 'Date of Service To', dateOfServiceTo);
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Date of Service', [{
            value: `${dateOfServiceFrom}-${dateOfServiceTo}`,
            label: `${dateOfServiceFrom}-${dateOfServiceTo}`,
          }]);
        } else {
          actions.clearFields(`${tabID}-workflow-ordersFilter`, 'Date of Service From');
          actions.clearFields(`${tabID}-workflow-ordersFilter`, 'Date of Service To');
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Date of Service', []);
        }
        if (scheduleOrdersFilterValues.Filters.City
          && scheduleOrdersFilterValues.Filters.City.length > 0) {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.City', scheduleOrdersFilterValues.Filters.City);
        } else {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.City', []);
        }
        if (scheduleOrdersFilterValues.Filters.Driver
          && scheduleOrdersFilterValues.Filters.Driver.length > 0) {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Driver', scheduleOrdersFilterValues.Filters.Driver);
        } else {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Driver', []);
        }
        if (scheduleOrdersFilterValues.Filters.Status
          && scheduleOrdersFilterValues.Filters.Status.length > 0) {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Status', scheduleOrdersFilterValues.Filters.Status);
        } else {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Status', []);
        }
        if (scheduleOrdersFilterValues.Filters.User
          && scheduleOrdersFilterValues.Filters.User.length > 0) {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.User', scheduleOrdersFilterValues.Filters.User);
        } else {
          actions.change(`${tabID}-workflow-ordersFilter`, 'Filters.Users', []);
        }
      } else {
        actions.clearFields('schedule-ordersFilter', 'Filters');
      }
    }
  }

  componentDidMount() {
    const { match, actions, location, tabID, archive, contextFiltersOptions } = this.props;
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const filterForm = archive ? `${tabID}-archive-ordersFilter` : `${tabID}-workflow-ordersFilter`;
    const navigationForm = `${tabID}-workflowNavigationFilter`;
    const dateFrom = params['date-of-creation-from'];
    const dateTo = params['date-of-creation-to'];

    if (dateFrom) {
      actions.change(filterForm, 'Date of Creation From', dateFrom);
    }
    if (dateTo) {
      actions.change(filterForm, 'Date of Creation To', dateTo);
    }
    if (dateFrom && dateTo) {
      actions.change(filterForm, 'Filters.Date of Creation', [{
        value: `${dateFrom}-${dateTo}`,
        label: `${dateFrom}-${dateTo}`,
      }]);
    }

    this.onRequest();
    actions.addRouterParamsRedirect({
      '/workflow': match.path,
    });
    actions.fetchBusiness({
      triggerLoading: false,
    });
    window.addEventListener('message', this.onWindowMessage);
  }

  componentWillReceiveProps(nextProps) {
    const {
      filters,
      sortBy,
      sort,
      count,
      loading,
    } = this.props;
    const nextOrderState = nextProps.filters['Workflow State']
      ? nextProps.filters['Workflow State'].join('')
      : null;
    const currentOrderState = filters['Workflow State']
      ? filters['Workflow State'].join('')
      : null;
    const nextIsRejected = nextProps.filters['Is Rejected']
      ? nextProps.filters['Is Rejected'].join('')
      : null;
    const currentIsRejected = filters['Is Rejected']
      ? filters['Is Rejected'].join('')
      : null;
    const nextAssignedUserID = nextProps.filters['Assigned User ID']
      ? nextProps.filters['Assigned User ID'].join('')
      : null;
    const currentAssignedUserID = filters['Assigned User ID']
      ? filters['Assigned User ID'].join('')
      : null;
    const nextStatus = nextProps.filters.Status
      ? nextProps.filters.Status.join('')
      : null;
    const currentStatus = filters.Status
      ? filters.Status.join('')
      : null;
    const nextDriverID = nextProps.filters['Driver ID']
      ? nextProps.filters['Driver ID'].join('')
      : null;
    const currentDriverID = filters['Driver ID']
      ? filters['Driver ID'].join('')
      : null;
    const nextInsuranceInfoID = nextProps.filters['Insurance Info ID']
      ? nextProps.filters['Insurance Info ID'].join('')
      : null;
    const currentInsuranceInfoID = filters['Insurance Info ID']
      ? filters['Insurance Info ID'].join('')
      : null;
    const nextCity = nextProps.filters.City
      ? nextProps.filters.City.join('')
      : null;
    const currentCity = filters.City
      ? filters.City.join('')
      : null;
    const nextLineType = nextProps.filters['Line Type']
      ? nextProps.filters['Line Type'].join('')
      : null;
    const currentLineType = filters['Line Type']
      ? filters['Line Type'].join('')
      : null;
    const nextSalesID = nextProps.filters['Sales Representative ID']
      ? nextProps.filters['Sales Representative ID'].join('')
      : null;
    const currentSalesID = filters['Sales Representative ID']
      ? filters['Sales Representative ID'].join('')
      : null;
    const nextReferralID = nextProps.filters['Referral Source ID']
      ? nextProps.filters['Referral Source ID'].join('')
      : null;
    const currentReferralID = filters['Referral Source ID']
      ? filters['Referral Source ID'].join('')
      : null;
    const nextPrescriberID = nextProps.filters['Prescriber ID']
    ? nextProps.filters['Prescriber ID'].join('')
    : null;
    const currentPrescriberID = filters['Prescriber ID']
      ? filters['Prescriber ID'].join('')
      : null;
    const nextHCPCSCodeID = nextProps.filters['HCPC S Code ID']
      ? nextProps.filters['HCPC S Code ID'].join('')
      : null;
    const currentHCPCSCodeID = filters['HCPC S Code ID']
      ? filters['HCPC S Code ID'].join('')
      : null;
    const nextWatcherID = nextProps.filters['Watcher ID']
      ? nextProps.filters['Watcher ID'].join('')
      : null;
    const currentWatcherID = filters['Watcher ID']
      ? filters['Watcher ID'].join('')
      : null;
    const nextPatientID = nextProps.filters['Patient ID']
      ? nextProps.filters['Patient ID'].join('')
      : null;
    const currentPatientID = filters['Patient ID']
      ? filters['Patient ID'].join('')
      : null;
    const filtersChanged =
      nextOrderState !== currentOrderState
      || nextProps.filters['Patient Date of Birth'] !== filters['Patient Date of Birth']
      || nextProps.filters['Order ID'] !== filters['Order ID']
      || nextProps.filters['Insurance Code'] !== filters['Insurance Code']
      || nextProps.filters['Claim Code'] !== filters['Claim Code']
      || nextProps.filters['Date of Service From'] !== filters['Date of Service From']
      || nextProps.filters['Date of Service To'] !== filters['Date of Service To']
      || nextProps.filters['Date of Creation From'] !== filters['Date of Creation From']
      || nextProps.filters['Date of Creation To'] !== filters['Date of Creation To']
      || nextProps.filters['Date of Delivery From'] !== filters['Date of Delivery From']
      || nextProps.filters['Date of Delivery To'] !== filters['Date of Delivery To']
      || nextProps.filters['Date of Claim Submission From'] !== filters['Date of Claim Submission From']
      || nextProps.filters['Date of Claim Submission To'] !== filters['Date of Claim Submission To']
      || nextPatientID !== currentPatientID
      || nextIsRejected !== currentIsRejected
      || nextAssignedUserID !== currentAssignedUserID
      || nextStatus !== currentStatus
      || nextDriverID !== currentDriverID
      || nextInsuranceInfoID !== currentInsuranceInfoID
      || nextCity !== currentCity
      || nextLineType !== currentLineType
      || nextSalesID !== currentSalesID
      || nextReferralID !== currentReferralID
      || nextPrescriberID !== currentPrescriberID
      || nextHCPCSCodeID !== currentHCPCSCodeID
      || nextWatcherID !== currentWatcherID;
    const sortByChanged = nextProps.sortBy !== sortBy;
    const sortChanged = nextProps.sort !== sort;
    if (filtersChanged || sortByChanged || sortChanged) {
      this.setState({ offset: 0 });
      window.scrollTo(0, 0);
    }
    // To be updated
    if (nextProps.count + 1 === count
      && loading === 0
      && nextProps.loading === 0) {
      this.onRequest({
        offset: 0,
        limit: this.state.offset + this.state.limit,
        push: false,
      }); // Fetch orders if order was deleted
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return ((Object.keys(objectDiff(this.props, nextProps)).length +
      Object.keys(objectDiff(this.state, nextState)).length) > 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { orders, filters, sortBy, sort, loading, count } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Order ID', 'Insurance Code', 'Claim Code'],
        throttledArrayFilterKeys: ['Workflow State'],
        immediateFilterKeys: [
          'Patient Date of Birth',
          'Date of Service From',
          'Date of Service To',
          'Date of Creation',
          'Date of Creation From',
          'Date of Creation To',
          'Date of Delivery From',
          'Date of Delivery To',
          'Date of Claim Submission From',
          'Date of Claim Submission To',
        ],
        arrayFilterKeys: [
          'Patient ID',
          'Assigned User ID',
          'Status',
          'Is Rejected',
          'Driver ID',
          'Insurance Info ID',
          'City',
          'Line Type',
          'Sales Representative ID',
          'Referral Source ID',
          'Prescriber ID',
          'HCPC S Code ID',
          'Watcher ID',
        ],
      },
    );
    const sortByChanged = prevProps.sortBy !== sortBy;
    const sortChanged = prevProps.sort !== sort;
    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (loading === 0
      && (limitChanged || offsetChanged || sortByChanged || sortChanged)) {
      this.onRequest();
    } else if (filtersChanged) {
      this.onRequest();
    } else if (orders.length < count
      && this.scrollRef
      && this.scrollRef.scrollTop === 0
      && loading === 0) {
      this.onTableScroll({ target: this.scrollRef });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.onWindowMessage);
  }

  onRequest(options = {}) {
    const { actions, filters, sortBy, sort, archive } = this.props;
    const { limit, offset } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map((key) => {
        let name = key;
        let operation;
        let caseSensitivity = null;
        let val = filters[key];
        switch (key) {
          case 'Workflow State':
            name = 'Workflow State ID';
            if (filters[key].length > 1) {
              operation = 'in';
            } else {
              operation = 'eq';
              val = filters[key][0];
            }
            break;
          case 'Is Rejected':
            if (filters[key].length > 1) {
              operation = 'in';
            } else {
              operation = 'eq';
              val = filters[key][0];
            }
            break;
          case 'Patient ID':
            operation = 'in';
            break;
          case 'Order ID':
            name = 'ID';
            operation = 'eq';
            break;
          case 'Date of Birth':
            operation = 'eq';
            break;
          case 'Insurance Code':
            operation = 'startswith';
            caseSensitivity = false;
            break;
          case 'Claim Code':
            operation = 'startswith';
            caseSensitivity = false;
            break;
          case 'Assigned User ID':
          case 'Driver ID':
          case 'Insurance Info ID':
          case 'Line Type':
          case 'Sales Representative ID':
          case 'Referral Source ID':
          case 'Prescriber ID':
          case 'City':
          case 'HCPC S Code ID':
          case 'Watcher ID':
            operation = 'in';
            break;
          case 'Date of Service From':
            name = 'Date of Service';
            operation = 'ge';
            break;
          case 'Date of Service To':
            name = 'Date of Service';
            operation = 'le';
            break;
          case 'Date of Creation':
            name = 'Date of Creation';
            operation = 'eq';
            break;
          case 'Date of Creation From':
            name = 'Date of Creation';
            operation = 'ge';
            break;
          case 'Date of Creation To':
            name = 'Date of Creation';
            operation = 'le';
            break;
          case 'Date of Delivery From':
            name = 'Date of Delivery';
            operation = 'ge';
            break;
          case 'Date of Delivery To':
            name = 'Date of Delivery';
            operation = 'le';
            break;
          case 'Date of Claim Submission From':
            name = 'Claim Create At';
            operation = 'ge';
            break;
          case 'Date of Claim Submission To':
            name = 'Claim Create At';
            operation = 'le';
            break;
          case 'Status':
            name = 'Workflow Status ID';
            operation = 'in';
            break;
          default:
            operation = 'startswith';
            caseSensitivity = false;
        }
        return {
          name,
          operation,
          val,
          ...caseSensitivity !== null ? { case_sensitivity: caseSensitivity } : {},
        };
      })
      : null;
    if (archive) {
      actions.fetchArchiveOrders({
        limit: options.limit !== undefined ? options.limit : limit,
        offset: options.offset !== undefined ? options.offset : offset,
        filters: requestFilters,
        ...sortBy ? {
          sortBy: [{
            name: sortBy,
            sort,
          }],
        } : {},
        triggerLoading: true,
        push: options.push !== undefined ? options.push : offset > 0,
      });
    } else {
      actions.fetchOrders({
        limit: options.limit !== undefined ? options.limit : limit,
        offset: options.offset !== undefined ? options.offset : offset,
        filters: requestFilters,
        ...sortBy ? {
          sortBy: [{
            name: sortBy,
            sort,
          }],
        } : {},
        triggerLoading: true,
        push: options.push !== undefined ? options.push : offset > 0,
      });
    }
  }

  onWindowKeyDowm(event) {
    if (event.keyCode === 13) {
      if (this.state.syncUpdatesSnackbarOpen) {
        this.onSyncUpdatesConfirm();
      } else {
        this.onGroupedUpdateConfirm();
      }
    }
  }

  onCreateDialogClose() {
    this.setState({ createDialogOpen: false });
  }

  onSelectedOrderLinesPrint(order) {
    this.setState({
      printDialogOpen: true,
      printDialogOrder: order,
    });
  }

  onPrintDialogClose() {
    this.setState({ printDialogOpen: false });
  }

  onPrintDialogSign(values) {
    this.setState({
      printDialogOpen: false,
      printFormValues: values,
      signDialogOpen: true,
    });
  }

  onSignDialogClose() {
    this.setState({ signDialogOpen: false });
  }

  onFormSubmitSuccess(values) {
    const { orderLines, actions } = this.props;
    const { groupedUpdateEmptyDriverIDs, groupedUpdateEmptyDateOfDeliveryIDs } = this.state;
    let emptyDriverIDs = values
      .filter(orderLine => (orderLine['Workflow Status'] && orderLine['Workflow Status'].filter(statusItem =>
        statusItem['Workflow State'].ID === 2).length > 0
        && !orderLine.Driver.ID))
      .map(orderLine => orderLine.ID);
    let emptyDateOfDeliveryIDs = values
      .filter(orderLine => (orderLine['Workflow Status'] && orderLine['Workflow Status'].filter(statusItem =>
        statusItem['Workflow State'].ID === 2).length > 0
        && !orderLine['Date of Delivery']))
      .map(orderLine => orderLine.ID);
    if (groupedUpdateEmptyDriverIDs) {
      emptyDriverIDs = [
        ...emptyDriverIDs,
        ...groupedUpdateEmptyDriverIDs,
      ];
    }
    if (groupedUpdateEmptyDateOfDeliveryIDs) {
      emptyDateOfDeliveryIDs = [
        ...emptyDateOfDeliveryIDs,
        ...groupedUpdateEmptyDateOfDeliveryIDs,
      ];
    }
    if (this.state.groupedUpdateValues) {
      this.setState({
        groupedUpdateSnackbarOpen: true,
        groupedUpdateEmptyDriverIDs: emptyDriverIDs.length > 0 ? emptyDriverIDs : null,
        groupedUpdateEmptyDateOfDeliveryIDs: emptyDateOfDeliveryIDs.length > 0 ? emptyDateOfDeliveryIDs : null,
      });
      window.addEventListener('keydown', this.onWindowKeyDowm);
    } else if (emptyDriverIDs.length > 0 || emptyDateOfDeliveryIDs.length > 0) {
      const notificationMessage = [
        emptyDriverIDs.length > 0
          ? `${formatSinglePlural({
            quantity: emptyDriverIDs.length,
            single: 'Code',
            plural: 'Codes',
          })} ${orderLines
              .filter(item => emptyDriverIDs.indexOf(item.ID) !== -1)
              .map(item => item['HCPC S Code']['HCPC S Code'])
              .join(', ')} ${formatSinglePlural({
            quantity: emptyDriverIDs.length,
            single: 'has',
            plural: 'have',
          })} missing Driver information`
          : null,
        emptyDateOfDeliveryIDs.length > 0
          ? `${formatSinglePlural({
            quantity: emptyDateOfDeliveryIDs.length,
            single: 'Code',
            plural: 'Codes',
          })} ${orderLines
              .filter(item => emptyDateOfDeliveryIDs.indexOf(item.ID) !== -1)
              .map(item => item['HCPC S Code']['HCPC S Code'])
              .join(', ')} ${formatSinglePlural({
            quantity: emptyDateOfDeliveryIDs.length,
            single: 'has',
            plural: 'have',
          })} missing Date of Delivery information`
          : null,
      ].filter(item => item).join(', ');
      actions.addNotification({
        message: notificationMessage,
        variant: 'info',
      });
      this.setState({
        groupedUpdateEmptyDriverIDs: null,
        groupedUpdateEmptyDateOfDeliveryIDs: null,
      });
    }
  }

  onFormChange(values, dispatch, props, prevValues) {
    const { actions, orders, selectedOrderLines } = this.props;
    const diffValues = objectDiff(values, prevValues);
    const changeFieldName = Object.keys(diffValues)[0];
    const statusChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName].Status !== undefined;
    const assignedUserChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName]['Assigned User ID'];
    const driverChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName]['Driver ID'] !== undefined;
    const placeOfServiceChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName]['Place of SRV'] !== undefined;
    const dateOfDeliveryChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName]['Date of Delivery'] !== undefined;
    const timeOfDeliveryChanged = diffValues[changeFieldName]
      && diffValues[changeFieldName]['Time of Delivery'] !== undefined;
    if (statusChanged) {
      diffValues[changeFieldName].Status = values[changeFieldName].Status;
    }
    if (changeFieldName
      && changeFieldName.indexOf('-orderLine') === -1
      && Object.keys(diffValues).length === 1) {
      const changeOrderID = Number(changeFieldName.replace('-order-selected', ''));
      const changeOrder = orders.find(item => item.ID === changeOrderID);
      if (diffValues[changeFieldName] && !prevValues[changeFieldName]) {
        changeOrder['Order Line'].forEach((orderLine) => {
          actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.selected`, true);
        });
      } else if (prevValues[changeFieldName]
          && !diffValues[changeFieldName]
          && changeOrder['Order Line'].filter(orderLine => values[`${orderLine.ID}-orderLine`].selected).length
        === changeOrder['Order Line'].length) {
        changeOrder['Order Line'].forEach((orderLine) => {
          actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.selected`, false);
        });
        actions.change('workflow-ordersForm', changeFieldName, false);
      }
    } else if (diffValues[changeFieldName]
      && diffValues[changeFieldName].selected !== undefined) {
      const changeOrderLineID = Number(changeFieldName.replace('-orderLine', ''));
      const changeOrder = orders.find(order => order['Order Line'].find(orderLine =>
        orderLine.ID === changeOrderLineID));
      if (diffValues[changeFieldName].selected === false
        && values[`${changeOrder.ID}-order-selected`] === true) {
        actions.change('workflow-ordersForm', `${changeOrder.ID}-order-selected`, false);
      } else if (diffValues[changeFieldName].selected === true
        && values[`${changeOrder.ID}-order-selected`] === false) {
        const allOrderLinesSelected = changeOrder['Order Line'].filter(orderLine =>
          values[`${orderLine.ID}-orderLine`].selected === true).length
          === changeOrder['Order Line'].length;
        if (allOrderLinesSelected) {
          actions.change('workflow-ordersForm', `${changeOrder.ID}-order-selected`, true);
        }
      }
    } else {
      Object.keys(values).forEach((orderLine) => {
        if (values[orderLine]['Assigned User ID']
          && values[orderLine]['Selected Assigned User Name']
            !== values[orderLine]['Assigned User Name']) {
          dispatch(props.change(`${orderLine}.Assigned User ID`, ''));
        }

        if (values[orderLine]['Driver ID']
          && values[orderLine]['Selected Driver Name']
            !== values[orderLine]['Driver Name']) {
          dispatch(props.change(`${orderLine}.Driver ID`, ''));
        }
      });

      if (!this.groupedUpdate
        && !props.pristine
        && diffValues[changeFieldName].selected === undefined
        && diffValues[changeFieldName].orderLineInsuranceParam === undefined
        && diffValues[changeFieldName]['Check Book Sheet'] === undefined
      ) {
        if (selectedOrderLines.length > 0) {
          if (selectedOrderLines.filter(item => `${item.ID}-orderLine` === changeFieldName).length > 0) {
            const selectedOrderLinesOrderIDs = [];
            this.groupedUpdate = true;
            selectedOrderLines.forEach((orderLine) => {
              if (selectedOrderLinesOrderIDs.indexOf(orderLine['Order ID']) === -1) {
                selectedOrderLinesOrderIDs.push(orderLine['Order ID']);
              }
              Object.keys(diffValues[changeFieldName]).forEach((filedName) => {
                actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.${filedName}`, diffValues[changeFieldName][filedName]);
              });
              if (diffValues[changeFieldName]['Assigned User Name']
                && !diffValues[changeFieldName]['Selected Assigned User Name']) {
                actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.Selected Assigned User Name`, diffValues[changeFieldName]['Assigned User Name']);
              }
            });
            // Delay to wait multiple async change actions to complete
            setTimeout(() => {
              if (selectedOrderLinesOrderIDs.length > 1) {
                this.setState({
                  syncUpdatesSnackbarOpen: true,
                  syncUpdatesSnackbarText: 'You are trying to update order lines from different orders, proceed?',
                  syncUpdatesSnackbarButtons: true,
                });
                window.addEventListener('keydown', this.onWindowKeyDowm);
              } else {
                actions.submit('workflow-ordersForm');
              }
              this.groupedUpdate = false;
            }, 200);
          } else {
            setTimeout(() => {
              actions.submit('workflow-ordersForm');
            }, 100);
          }
        } else if (statusChanged || assignedUserChanged || driverChanged
          || placeOfServiceChanged || dateOfDeliveryChanged || timeOfDeliveryChanged) {
          const changeOrderLineID = Number(changeFieldName.replace('-orderLine', ''));
          const changeOrder = orders.find(order =>
            order['Order Line'].findIndex(orderLine =>
              orderLine.ID === changeOrderLineID) !== -1);
          if (changeOrder['Order Line'].length > 1) {
            this.setState({
              groupedUpdateValues: {
                ...diffValues[changeFieldName],
                ...diffValues[changeFieldName]['Driver ID'] === '' ? {
                  'Driver Name': '',
                  'Selected Driver Name': '',
                } : {},
              },
              groupedUpdateOrderID: changeOrder.ID,
            });
          }
          setTimeout(() => {
            actions.submit('workflow-ordersForm');
          }, 100);
        }
      }
    }
  }

  onFormTextFieldBlur(diffValues) {
    const { orders, actions, selectedOrderLines } = this.props;
    const changeFieldName = Object.keys(diffValues)[0];
    const changeOrderLineID = Number(changeFieldName.replace('-orderLine', ''));
    if (selectedOrderLines.length > 0) {
      if (selectedOrderLines.filter(item => item.ID === changeOrderLineID).length > 0) {
        const otherOrderIDs = [];
        const noCorrespondingInsuranceOrderIDs = [];
        this.groupedUpdate = true;
        const changeInsuranceID = diffValues[changeFieldName].orderLineInsuranceParam
          ? Number(Object.keys(diffValues[changeFieldName].orderLineInsuranceParam)[0].replace('insuranceID-', ''))
          : Number(Object.keys(diffValues[changeFieldName]['Check Book Sheet'])[0].replace('insuranceID-', ''));
        const changeOrder = orders.find(order =>
          order['Order Line'].findIndex(orderLineItem =>
            orderLineItem.ID === changeOrderLineID) !== -1);
        const changePayerID = changeOrder.Insurance.find(item =>
          item.ID === changeInsuranceID).ID;
        selectedOrderLines.forEach((orderLine) => {
          const currentOrder = orders.find(order =>
            order['Order Line'].findIndex(orderLineItem =>
              orderLineItem.ID === orderLine.ID) !== -1);
          const currentChangeInsurance = currentOrder.Insurance.find(item =>
            item.ID === changePayerID);
          const isOtherOrder = currentOrder['Order Line'].filter(item => item.ID === changeOrderLineID).length === 0;
          if (isOtherOrder && otherOrderIDs.indexOf(orderLine['Order ID']) === -1) {
            otherOrderIDs.push(orderLine['Order ID']);
          }
          if (isOtherOrder
            && !currentChangeInsurance
            && noCorrespondingInsuranceOrderIDs.indexOf(orderLine['Order ID']) === -1) {
            noCorrespondingInsuranceOrderIDs.push(orderLine['Order ID']);
          }
          if (currentChangeInsurance) {
            Object.keys(diffValues[changeFieldName]).forEach((fieldName) => {
              if (typeof diffValues[changeFieldName][fieldName] === 'object') {
                Object.keys(diffValues[changeFieldName][fieldName]).forEach((nestedFieldName) => {
                  if (typeof diffValues[changeFieldName][fieldName][nestedFieldName] === 'object') {
                    Object.keys(diffValues[changeFieldName][fieldName][nestedFieldName])
                      .forEach((innerNestedFieldName) => {
                        actions.change('workflow-ordersForm',
                          `${orderLine.ID}-orderLine.${fieldName}.insuranceID-${currentChangeInsurance.ID}.${innerNestedFieldName}`,
                          diffValues[changeFieldName][
                            fieldName
                          ][nestedFieldName][innerNestedFieldName]);
                      });
                  }
                });
              } else {
                actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.${fieldName}`, diffValues[changeFieldName][fieldName]);
              }
            });
          }
        });
        // Delay to wait multiple async change actions to complete
        setTimeout(() => {
          if (otherOrderIDs.length > 0) {
            if (otherOrderIDs.length === noCorrespondingInsuranceOrderIDs.length) {
              this.setState({
                syncUpdatesSnackbarOpen: true,
                syncUpdatesSnackbarText: 'Selected Order Lines do not have same Insurance, so update will not be synchronized',
                syncUpdatesSnackbarButtons: false,
              });
              actions.submit('workflow-ordersForm');
            } else if (noCorrespondingInsuranceOrderIDs.length === 0) {
              this.setState({
                syncUpdatesSnackbarOpen: true,
                syncUpdatesSnackbarText: 'You are trying to update order lines from different orders, proceed?',
                syncUpdatesSnackbarButtons: true,
              });
              window.addEventListener('keydown', this.onWindowKeyDowm);
            } else {
              this.setState({
                syncUpdatesSnackbarOpen: true,
                syncUpdatesSnackbarText: `You are trying to update order lines from different orders, proceed?
                  Please note, selected Order Lines from
                  ${formatSinglePlural({ quantity: noCorrespondingInsuranceOrderIDs.length, single: 'Order', plural: 'Orders' })}
                  ${noCorrespondingInsuranceOrderIDs.map(item => formatOrderNumber(item)).join(', ')}
                  do not have same Insurance, so update will not be synchronized`,
                syncUpdatesSnackbarButtons: true,
              });
              window.addEventListener('keydown', this.onWindowKeyDowm);
            }
          } else {
            actions.submit('workflow-ordersForm');
          }
          this.groupedUpdate = false;
        }, 200);
      } else {
        setTimeout(() => {
          actions.submit('workflow-ordersForm');
        }, 100);
      }
    } else {
      const changeInsuranceKey = diffValues[changeFieldName].orderLineInsuranceParam
          ? Object.keys(diffValues[changeFieldName].orderLineInsuranceParam)[0]
          : null;
      const changeOrder = orders.find(order =>
        order['Order Line'].findIndex(orderLine =>
          orderLine.ID === changeOrderLineID) !== -1);
      if (changeOrder['Order Line'].length > 1
      && (!changeInsuranceKey || !diffValues[changeFieldName].orderLineInsuranceParam[changeInsuranceKey].Reimbs)) {
        this.setState({
          groupedUpdateValues: diffValues[changeFieldName],
          groupedUpdateOrderID: changeOrder.ID,
        });
      }
      setTimeout(() => {
        actions.submit('workflow-ordersForm');
      }, 100);
    }
  }

  onGroupedUpdateConfirm() {
    const { actions, orders } = this.props;
    const { groupedUpdateValues, groupedUpdateOrderID } = this.state;
    const groupedUpdateOrder = orders.find(order => order.ID === groupedUpdateOrderID);
    this.groupedUpdate = true;
    this.setState({
      groupedUpdateValues: null,
      groupedUpdateSnackbarOpen: false,
    });
    window.removeEventListener('keydown', this.onWindowKeyDowm);
    groupedUpdateOrder['Order Line'].forEach((orderLine) => {
      Object.keys(groupedUpdateValues).forEach((fieldName) => {
        if (typeof groupedUpdateValues[fieldName] === 'object') {
          Object.keys(groupedUpdateValues[fieldName]).forEach((nestedFieldName) => {
            if (typeof groupedUpdateValues[fieldName][nestedFieldName] === 'object') {
              Object.keys(groupedUpdateValues[fieldName][nestedFieldName])
                .forEach((innerNestedFieldName) => {
                  actions.change('workflow-ordersForm',
                    `${orderLine.ID}-orderLine.${fieldName}.${nestedFieldName}.${innerNestedFieldName}`,
                    groupedUpdateValues[fieldName][nestedFieldName][innerNestedFieldName]);
                });
            }
          });
        } else {
          actions.change('workflow-ordersForm', `${orderLine.ID}-orderLine.${fieldName}`, groupedUpdateValues[fieldName]);
        }
      });
    });
    // Delay to wait multiple async change actions to complete
    setTimeout(() => {
      actions.submit('workflow-ordersForm');
      this.groupedUpdate = false;
    }, 200);
  }

  onGroupedUpdateSnackbarClose() {
    const { orderLines, actions } = this.props;
    const { groupedUpdateEmptyDriverIDs, groupedUpdateEmptyDateOfDeliveryIDs } = this.state;
    const newState = {
      groupedUpdateValues: null,
      groupedUpdateSnackbarOpen: false,
    };
    if ((groupedUpdateEmptyDriverIDs || groupedUpdateEmptyDateOfDeliveryIDs) && !this.groupedUpdate) {
      const notificationMessage = [
        groupedUpdateEmptyDriverIDs.length > 0
          ? `${formatSinglePlural({
            quantity: groupedUpdateEmptyDriverIDs.length,
            single: 'Code',
            plural: 'Codes',
          })} ${orderLines
              .filter(item => groupedUpdateEmptyDriverIDs.indexOf(item.ID) !== -1)
              .map(item => item['HCPC S Code']['HCPC S Code'])
              .join(', ')} ${formatSinglePlural({
            quantity: groupedUpdateEmptyDriverIDs.length,
            single: 'has',
            plural: 'have',
          })} missing Driver information`
          : null,
        groupedUpdateEmptyDateOfDeliveryIDs.length > 0
          ? `${formatSinglePlural({
            quantity: groupedUpdateEmptyDateOfDeliveryIDs.length,
            single: 'Code',
            plural: 'Codes',
          })} ${orderLines
              .filter(item => groupedUpdateEmptyDateOfDeliveryIDs.indexOf(item.ID) !== -1)
              .map(item => item['HCPC S Code']['HCPC S Code'])
              .join(', ')} ${formatSinglePlural({
            quantity: groupedUpdateEmptyDateOfDeliveryIDs.length,
            single: 'has',
            plural: 'have',
          })} missing Date of Delivery information`
          : null,
      ].filter(item => item).join(', ');
      actions.addNotification({
        message: notificationMessage,
        variant: 'info',
      });
      newState.groupedUpdateEmptyDriverIDs = null;
      newState.groupedUpdateEmptyDateOfDeliveryIDs = null;
    }
    this.setState(newState);
    window.removeEventListener('keydown', this.onWindowKeyDowm);
  }

  onSyncUpdatesConfirm() {
    const { actions } = this.props;
    actions.submit('workflow-ordersForm');
    this.setState({ syncUpdatesSnackbarOpen: false });
    window.removeEventListener('keydown', this.onWindowKeyDowm);
  }

  onSyncUpdatesSnackbarClose() {
    this.setState({ syncUpdatesSnackbarOpen: false });
    window.removeEventListener('keydown', this.onWindowKeyDowm);
  }

  onSortingChange(newSortBy) {
    const { actions, location, sort, sortBy } = this.props;
    let newSort;
    if (sortBy !== newSortBy) {
      newSort = newSortBy === 'Date of Creation' ? 'desc' : 'asc';
    } else {
      newSort = sort === 'asc' ? 'desc' : 'asc';
    }
    actions.addRouterParamsPageSettings({
      [location.pathname]: {
        sortBy: newSortBy,
        sort: newSort,
      },
    });
  }

  onOrdersActionsBarEntered() {
    this.setState({ ordersActionsBarEntered: true });
  }

  onOrdersActionsBarExited() {
    this.setState({ ordersActionsBarEntered: false });
  }

  onTableScroll(event) {
    const { offset, limit } = this.state;

    if ((event.target.offsetHeight + event.target.scrollTop) / event.target.scrollHeight > 0.9) {
      if ((this.props.orders.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
        });
      }
    }
  }

  onWindowMessage(event) {
    const { actions } = this.props;
    if (event.data.type && event.data.type === 'order-update-success' && event.data.values && event.data.values.data) {
      Object.keys(event.data.values.data).forEach((orderID) => {
        actions.updateOrderSuccess(event.data.values.data[orderID]);
      });
      actions.addNotification({
        message: 'Order successfully updated',
        variant: 'success',
      });
    }
  }

  onToolbarResize({ expandedView, expansionDetailsHeight, mobileFilterHeight }) {
    this.setState({
      toolbarExpanded: expandedView,
      toolbarHeight: expansionDetailsHeight,
      mobileFilterHeight: mobileFilterHeight,
    });
  }

  onMobileFilterBottonClick() {
    this.setState({ mobileFilterExpanded: !this.state.mobileFilterExpanded });
  }

  render() {
    const {
      orders,
      count,
      loading,
      selectedOrderLines,
      selectedOrders,
      orderLines,
      actions,
      sort,
      sortBy,
      contextFiltersOptions,
      scheduleOrdersFilterValues,
      business,
      tabID,
      location,
      archive,
      classes,
      width,
      filters,
      theme,
    } = this.props;
    const {
      printDialogOpen,
      signDialogOpen,
      printFormValues,
      printDialogOrder,
      groupedUpdateSnackbarOpen,
      syncUpdatesSnackbarOpen,
      syncUpdatesSnackbarText,
      syncUpdatesSnackbarButtons,
      ordersActionsBarEntered,
      toolbarExpanded,
      toolbarHeight,
      limit,
      offset,
      mobileFilterExpanded,
      mobileFilterHeight,
    } = this.state;
    const ordersActionsBarOpen = selectedOrderLines.length > 0;
    let tableHeightAdjustment = toolbarExpanded ? toolbarHeight + 255 : 255;
    if (width === 'xs' || width === 'sm') {
      tableHeightAdjustment = mobileFilterExpanded ? mobileFilterHeight + 177 : 169;
    }
    if (ordersActionsBarOpen) {
      tableHeightAdjustment += 72;
    }
    return (
      <Layout className={classes.layout}>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Workflow
          </title>
        </Helmet>
        <StickyToolbar>
          <NavigationFilter
            form={`${tabID}-workflowNavigationFilter`}
            variant="workflow"
            destroyOnUnmount={false}
            scheduleOrdersFilterValues={scheduleOrdersFilterValues}
            archive={archive}
            onMobileFilterBottonClick={this.onMobileFilterBottonClick}
            filters={filters}
          />
          <OrdersFilter
            variant="workflow"
            form={archive ? `${tabID}-archive-ordersFilter`: `${tabID}-workflow-ordersFilter`}
            navigationFormName={`${tabID}-workflowNavigationFilter`}
            destroyOnUnmount={false}
            contextFiltersOptions={contextFiltersOptions}
            onExpansionChange={this.onToolbarResize}
            mobileFilterExpanded={mobileFilterExpanded}
          />
        </StickyToolbar>
        {loading > 0 &&
          <Progress fixed />
        }
        <ExpansionPanel
          className={classes.expansionPanel}
          elevation={0}
          expanded={width === 'xs' || width === 'sm' ? mobileFilterExpanded : toolbarExpanded}
          CollapseProps={{
            timeout: theme.transitions.duration.short,
          }}
        >
          <ExpansionPanelDetails
            className={classes.expansionPanelDetails}
          >
            <div
              style={{
                height: width === 'xs' || width === 'sm' ? mobileFilterHeight + 8 : toolbarHeight,
              }}
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <div className={classes.tableContainer}>
          <OrdersTable
            style={{
              height: `calc(100vh - ${tableHeightAdjustment}px)`,
              height: `calc(100dvh - ${tableHeightAdjustment}px)`,
            }}
            items={orders}
            count={count}
            variant="workflow"
            form="workflow-ordersForm"
            sort={sort}
            sortBy={sortBy}
            onSortingChange={this.onSortingChange}
            onChange={this.onFormChange}
            onSubmitSuccess={this.onFormSubmitSuccess}
            onFormTextFieldBlur={this.onFormTextFieldBlur}
            onStockLineCreate={this.onRequest}
            initialValues={orders.reduce((ordersAccumulator, currentOrder) => ({
              ...ordersAccumulator,
              ...{
                [`${currentOrder.ID}-order-selected`]: selectedOrders.filter(order =>
                  order.ID === currentOrder.ID).length > 0,
              },
              ...currentOrder['Order Line']
                .reduce((orderLinesAccumulator, currentOrderLineValue) => ({
                  ...orderLinesAccumulator,
                  [`${currentOrderLineValue.ID}-orderLine`]: {
                    selected: selectedOrderLines.findIndex(selectedOrderLine =>
                      selectedOrderLine.ID === currentOrderLineValue.ID) !== -1,
                    Status: currentOrderLineValue['Workflow Status'].map(item => ({
                      value: item.ID,
                      label: item.Name,
                    })),
                    ...currentOrderLineValue['Assigned User'].ID ? {
                      'Assigned User ID': currentOrderLineValue['Assigned User'].ID,
                      'Assigned User Name': `${currentOrderLineValue['Assigned User']['First Name']} ${currentOrderLineValue['Assigned User']['Last Name']}`,
                      'Selected Assigned User Name': `${currentOrderLineValue['Assigned User']['First Name']} ${currentOrderLineValue['Assigned User']['Last Name']}`,
                    } : {
                      'Assigned User ID': 'unassigned',
                    },
                    ...currentOrderLineValue.Driver.ID ? {
                      'Driver ID': currentOrderLineValue.Driver.ID,
                      'Driver Name': `${currentOrderLineValue.Driver['First Name']} ${currentOrderLineValue.Driver['Last Name']}`,
                      'Selected Driver Name': `${currentOrderLineValue.Driver['First Name']} ${currentOrderLineValue.Driver['Last Name']}`,
                    } : {},
                    ...currentOrderLineValue['Date of Delivery'] ? {
                      'Date of Delivery': moment(currentOrderLineValue['Date of Delivery'], timeDateFormat).format(dateFormat),
                      'Time of Delivery': moment(currentOrderLineValue['Date of Delivery'], timeDateFormat).format(timeFormat),
                    } : {},
                    ...currentOrderLineValue['Place of SRV'] ? {
                      'Place of SRV': currentOrderLineValue['Place of SRV'],
                    } : {},
                    ...currentOrderLineValue.Reimbs && currentOrderLineValue.Reimbs !== 'None' ? { Reimbs: formatPrice(currentOrderLineValue.Reimbs) } : {},
                    ...currentOrderLineValue['Reimbs Date'] ? { 'Reimbs Date': currentOrderLineValue['Reimbs Date'] } : {},
                    ...currentOrderLineValue['Check Book Sheet Link'] && currentOrderLineValue['Check Book Sheet Link'].length > 0
                      ? { 'Check Book Sheet': currentOrderLineValue['Check Book Sheet Link']
                        .reduce((accumulator, currentValue) => {
                          if (currentValue['Check Book Sheet'].length === 0) {
                            return accumulator;
                          }
                          return {
                            ...accumulator,
                            [`insuranceID-${currentValue['Insurance ID']}`]: {
                              'Check Number':
                                currentValue['Check Book Sheet'][currentValue['Check Book Sheet'].length - 1]['Check Number'],
                              'Check Book Sheet ID':
                                currentValue['Check Book Sheet'][currentValue['Check Book Sheet'].length - 1].ID,
                            },
                          };
                        }, {}),
                      } : {},
                    ...currentOrderLineValue['Order Line Insurance Param']
                      && currentOrderLineValue['Order Line Insurance Param'].length > 0 ? {
                        orderLineInsuranceParam: currentOrderLineValue['Order Line Insurance Param']
                          .reduce((accumulator, currentValue) => ({
                            ...accumulator,
                            [`insuranceID-${currentValue.Insurance.ID}`]: {
                              ...currentValue.ID ? {
                                ID: currentValue.ID,
                              } : {},
                              ...currentValue.Reimbs ? {
                                Reimbs: formatPrice(currentValue.Reimbs),
                              } : {},
                              ...currentValue['Reimbs Date'] ? {
                                'Reimbs Date': currentValue['Reimbs Date'],
                              } : {},
                            },
                          }), {}),
                      } : {},
                    orderID: currentOrder.ID,
                  },
                }), {}),
            }), {})}
            loading={loading}
            business={business}
            mobileFilterExpanded={false}
            onScroll={this.onTableScroll}
            scrollRef={(scrollRef) => { this.scrollRef = scrollRef; }}
          />
        </div>
        {ordersActionsBarEntered &&
          <div style={{ height: '72px' }} />
        }
        <OrdersActionsBar
          open={ordersActionsBarOpen}
          count={selectedOrderLines.length}
          totalCount={orderLines.length}
          selectedOrderLines={selectedOrderLines}
          onPrint={this.onSelectedOrderLinesPrint}
          onSelect={() => {
            orders.forEach((order) => {
              order['Order Line'].forEach((orderLine) => {
                actions.change(
                  'workflow-ordersForm',
                  `${orderLine.ID}-orderLine.selected`,
                  true,
                );
              });
              actions.change('workflow-ordersForm', `${order.ID}-order-selected`, true);
            });
          }}
          onDeselect={() => {
            orders.forEach((order) => {
              order['Order Line'].forEach((orderLine) => {
                actions.change(
                  'workflow-ordersForm',
                  `${orderLine.ID}-orderLine.selected`,
                  false,
                );
              });
              actions.change('workflow-ordersForm', `${order.ID}-order-selected`, false);
            });
          }}
          onSubmitSuccess={(values) => {
            values.forEach((orderLine) => {
              actions.change(
                'workflow-ordersForm',
                `${orderLine.ID}-orderLine.selected`,
                false,
              );
            });
            this.onRequest({
              push: false,
              offset: 0,
              limit: offset + limit,
            });
          }}
          variant="combined"
          orders={orders}
          onEntered={this.onOrdersActionsBarEntered}
          onExited={this.onOrdersActionsBarExited}
          archive={archive}
        />
        {printDialogOrder &&
          <Fragment>
            <PrintDialog
              form={`${printDialogOrder.ID}-orderPrint`}
              variant="order"
              open={printDialogOpen}
              onClose={this.onPrintDialogClose}
              onSign={this.onPrintDialogSign}
              ID={printDialogOrder.ID}
              patient={printDialogOrder.Patient}
              prescriber={printDialogOrder.Prescriber}
              {...{
                'Order Line': printDialogOrder['Order Line'],
                'Primary Insurance': printDialogOrder['Primary Insurance'],
                'Order Insurance Param': printDialogOrder['Order Insurance Param'],
              }}
            />
            <DocumentsSignDialog
              open={signDialogOpen}
              onClose={this.onSignDialogClose}
              printFormValues={printFormValues}
              variant="order"
              ID={printDialogOrder.ID}
              patient={printDialogOrder.Patient}
              prescriber={printDialogOrder.Prescriber}
              {...{
                'Order Line': printDialogOrder['Order Line'],
                'Primary Insurance': printDialogOrder['Primary Insurance'],
                'Order Insurance Param': printDialogOrder['Order Insurance Param'],
              }}
            />
          </Fragment>
        }
        <Snackbar
          open={groupedUpdateSnackbarOpen}
          variant="success"
          message="Order was successfully updated. Apply this update to other order lines?"
          autoHideDuration={3000}
          resumeHideDuration={0}
          onClose={this.onGroupedUpdateSnackbarClose}
          action={(
            <Button
              variant="raised"
              color="primary"
              onClick={this.onGroupedUpdateConfirm}
            >
              Submit
            </Button>
          )}
        />
        <Snackbar
          open={syncUpdatesSnackbarOpen}
          variant="warning"
          message={syncUpdatesSnackbarText}
          autoHideDuration={6000}
          resumeHideDuration={0}
          onClose={this.onSyncUpdatesSnackbarClose}
          action={syncUpdatesSnackbarButtons ? (
            <Button
              variant="raised"
              color="primary"
              onClick={this.onSyncUpdatesConfirm}
            >
              Submit
            </Button>
          ) : null}
        />
      </Layout>
    );
  }
}

Orders.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  selectedOrders: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number.isRequired,
  filters: PropTypes.shape({
    'Patient Name / Patient ID': PropTypes.string,
    'Patient Date of Birth': PropTypes.string,
    'Order ID': PropTypes.string,
    'Insurance Code': PropTypes.string,
    'Claim Code': PropTypes.string,
    'HCPC S Code ID': PropTypes.arrayOf(PropTypes.number),
    'Assigned User ID': PropTypes.arrayOf(PropTypes.number),
    'Sales Representative ID': PropTypes.arrayOf(PropTypes.number),
    'Referral Source ID': PropTypes.arrayOf(PropTypes.number),
    'Workflow State': PropTypes.arrayOf(PropTypes.number),
    'Is Rejected': PropTypes.arrayOf(PropTypes.bool),
    Status: PropTypes.arrayOf(PropTypes.number),
    'Driver ID': PropTypes.arrayOf(PropTypes.number),
    'Insurance Info ID': PropTypes.arrayOf(PropTypes.number),
    'City': PropTypes.arrayOf(PropTypes.string),
    'Line Type': PropTypes.arrayOf(PropTypes.string),
    'Date of Service From': PropTypes.string,
    'Date of Service To': PropTypes.string,
    'Date of Creation From': PropTypes.string,
    'Date of Creation To': PropTypes.string,
    'Date of Delivery From': PropTypes.string,
    'Date of Delivery To': PropTypes.string,
    'Date of Claim Submission From': PropTypes.string,
    'Date of Claim Submission To': PropTypes.string,
  }).isRequired,
  orderLines: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  selectedOrderLines: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
    state: PropTypes.shape({}),
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  contextFiltersOptions: PropTypes.shape({
    statuses: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
    orderLineTypes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
  }),
  actions: PropTypes.shape({
    fetchOrders: PropTypes.func.isRequired,
    clearOrders: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    clearFields: PropTypes.func.isRequired,
    addRouterParamsRedirect: PropTypes.func.isRequired,
    addRouterParamsPageSettings: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  scheduleOrdersFilterValues: PropTypes.shape({
    Filters: PropTypes.shape({
      'Date of Delivery': PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
    }),
  }),
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  tabID: PropTypes.number.isRequired,
  archive: PropTypes.bool,
  classes: PropTypes.shape({
    expansionPanelDetails: PropTypes.string.isRequired,
  }).isRequired,
};

Orders.defaultProps = {
  sortBy: 'Date of Creation',
  sort: 'desc',
  contextFiltersOptions: null,
  scheduleOrdersFilterValues: {},
  business: {},
  archive: false,
};

const mapStateToProps = (store, ownProps) => {
  const ordersFilterValues = ownProps.archive
    ? getFormValues(`${store.tabID}-archive-ordersFilter`)(store)
    : getFormValues(`${store.tabID}-workflow-ordersFilter`)(store);
  const ordersFormValues = getFormValues('workflow-ordersForm')(store);
  const scheduleOrdersFilterValues = getFormValues('schedule-ordersFilter')(store);
  const navigationFormValues = getFormValues(`${store.tabID}-workflowNavigationFilter`)(store);
  const orderLines = ownProps.archive
    ? store.archiveOrders.data.reduce((accumulator, currentValue) => ([
      ...accumulator,
      ...currentValue['Order Line'],
    ]), [])
    : store.orders.data.reduce((accumulator, currentValue) => ([
    ...accumulator,
    ...currentValue['Order Line'],
  ]), []);
  const selectedOrderLines = ordersFormValues
    ? Object.keys(ordersFormValues)
      .filter(orderLine => orderLine.indexOf('-orderLine') !== -1
        && ordersFormValues[orderLine].selected === true)
      .map(orderLine => orderLines.find(item => item.ID === Number(orderLine.replace('-orderLine', ''))))
      .filter(item => item)
    : [];
  const selectedOrders = ordersFormValues && selectedOrderLines.length > 0
    ? Object.keys(ordersFormValues)
      .filter(filedName => filedName.indexOf('-order-selected') !== -1
        && ordersFormValues[filedName] === true)
      .map(filedName => store.orders.data.find(item => item.ID === Number(filedName.replace('-order-selected', ''))))
      .filter(item => item)
    : [];
  const State = [
    ...navigationFormValues
      && navigationFormValues.Intake ? [1] : [],
    ...navigationFormValues
      && navigationFormValues.Delivery ? [2] : [],
    ...navigationFormValues
      && navigationFormValues.Billing ? [3] : [],
    ...navigationFormValues
      && navigationFormValues.Collection ? [4] : [],
    ...navigationFormValues
      && navigationFormValues.Paid ? [5] : [],
  ];
  return {
    orders: ownProps.archive ? store.archiveOrders.data : store.orders.data,
    count: ownProps.archive ? store.archiveOrders.count : store.orders.count,
    contextFiltersOptions: ownProps.archive ? store.archiveOrders.contextFiltersOptions : store.orders.contextFiltersOptions,
    archive: ownProps.archive,
    filters: {
      ...State.length > 0 ? { 'Workflow State': State } : {},
      ...navigationFormValues
        && navigationFormValues.Rejected
        && State.length === 0
        ? {
          'Is Rejected': [true],
        } : {},
      ...navigationFormValues
        && !navigationFormValues.Rejected
        && State.length === 0
        ? {
          'Is Rejected': [false],
        } : {},
      ...navigationFormValues
        && navigationFormValues.Rejected
        && State.length > 0
        ? { 'Is Rejected': [true, false] } : {},
      ...ordersFilterValues
        && ordersFilterValues.Patients
        && ordersFilterValues.Patients.length > 0
        ? { 'Patient ID': ordersFilterValues.Patients.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Patient Date of Birth']
        && !validate.date(ordersFilterValues['Patient Date of Birth'])
        ? { 'Patient Date of Birth': moment(ordersFilterValues['Patient Date of Birth'], dateFormat).format(dateFormat) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Order ID']
        ? { 'Order ID': ordersFilterValues['Order ID'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Patient Insurance Code']
        ? { 'Insurance Code': ordersFilterValues['Patient Insurance Code'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['Claim Code']
        ? { 'Claim Code': ordersFilterValues['Claim Code'] }
        : {},
      ...ordersFilterValues
        && ordersFilterValues['HCPC Code']
        && ordersFilterValues['HCPC Code'].length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.hcpcsCodes.filter(item =>
            ordersFilterValues['HCPC Code'].filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'HCPC S Code ID': ordersFilterValues['HCPC Code'].map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.City
        && ordersFilterValues.City.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.cities.filter(item =>
            ordersFilterValues.City.filter(filterItem => filterItem.value === item.name).length === 0).length > 0)
        ? { 'City': ordersFilterValues.City.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.User
        && ordersFilterValues.Filters.User.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.users.filter(item =>
            ordersFilterValues.Filters.User.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Assigned User ID': ordersFilterValues.Filters.User.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Status
        && ordersFilterValues.Filters.Status.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.statuses.filter(item =>
            ordersFilterValues.Filters.Status.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { Status: ordersFilterValues.Filters.Status.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Driver
        && ordersFilterValues.Filters.Driver.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.drivers.filter(item =>
            ordersFilterValues.Filters.Driver.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Driver ID': ordersFilterValues.Filters.Driver.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Payer
        && ordersFilterValues.Filters.Payer.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.insurances.filter(item =>
            ordersFilterValues.Filters.Payer.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Insurance Info ID': ordersFilterValues.Filters.Payer.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Watcher
        && ordersFilterValues.Filters.Watcher.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.watchers.filter(item =>
            ordersFilterValues.Filters.Watcher.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Watcher ID': ordersFilterValues.Filters.Watcher.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Type
        && ordersFilterValues.Filters.Type.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.orderLineTypes.filter(item =>
            ordersFilterValues.Filters.Type.filter(filterItem => filterItem.value === item.name).length === 0).length > 0)
        ? { 'Line Type': ordersFilterValues.Filters.Type.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Sales
        && ordersFilterValues.Filters.Sales.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.sales.filter(item =>
            ordersFilterValues.Filters.Sales.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Sales Representative ID': ordersFilterValues.Filters.Sales.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Referral
        && ordersFilterValues.Filters.Referral.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.referralSources.filter(item =>
            ordersFilterValues.Filters.Referral.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Referral Source ID': ordersFilterValues.Filters.Referral.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters.Prescriber
        && ordersFilterValues.Filters.Prescriber.length > 0
        && (!store.orders.contextFiltersOptions
          || store.orders.contextFiltersOptions.prescribers.filter(item =>
            ordersFilterValues.Filters.Prescriber.filter(filterItem => filterItem.value === item.ID).length === 0).length > 0)
        ? { 'Prescriber ID': ordersFilterValues.Filters.Prescriber.map(item => item.value) }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Service']
        && ordersFilterValues.Filters['Date of Service'].length > 0
        ? {
          'Date of Service From': ordersFilterValues.Filters['Date of Service'][0].value.split('-')[0],
          'Date of Service To': ordersFilterValues.Filters['Date of Service'][0].value.split('-')[1],
        }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Creation']
        && ordersFilterValues.Filters['Date of Creation'].length > 0
        ? {
          'Date of Creation From': ordersFilterValues.Filters['Date of Creation'][0].value.split('-')[0],
          'Date of Creation To': ordersFilterValues.Filters['Date of Creation'][0].value.split('-')[1],
        }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Delivery']
        && ordersFilterValues.Filters['Date of Delivery'].length > 0
        ? {
          'Date of Delivery From': ordersFilterValues.Filters['Date of Delivery'][0].value.split('-')[0],
          'Date of Delivery To': ordersFilterValues.Filters['Date of Delivery'][0].value.split('-')[1],
        }
        : {},
      ...ordersFilterValues
        && ordersFilterValues.Filters
        && ordersFilterValues.Filters['Date of Claim Submission']
        && ordersFilterValues.Filters['Date of Claim Submission'].length > 0
        ? {
          'Date of Claim Submission From': ordersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[0],
          'Date of Claim Submission To': ordersFilterValues.Filters['Date of Claim Submission'][0].value.split('-')[1],
        }
        : {},
    },
    loading: ownProps.archive ? store.archiveOrders.loading : store.orders.loading,
    orderLines,
    selectedOrderLines,
    selectedOrders,
    ...store.routerParams.pageSettings[ownProps.location.pathname],
    scheduleOrdersFilterValues,
    business: store.business.data,
    tabID: store.tabID,
    account: store.account,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchOrders,
    clearOrders,
    updateOrderSuccess,
    fetchArchiveOrders,
    clearArchiveOrders,
    change,
    reset,
    clearFields,
    submit,
    addRouterParamsRedirect,
    addRouterParamsPageSettings,
    addNotification,
    fetchBusiness,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(withWidth()(withTheme()(Orders))),
);



// WEBPACK FOOTER //
// ./src/pages/workflow/Orders.js